import type { ServiceConfig } from '@/services/httpServices/types';

import { createQueryKey } from './queryKeyUtils';

export function userRoleQueryKey(config?: ServiceConfig) {
  return createQueryKey(['userRole'], config);
}

export const userQueryKey = () => createQueryKey(['user']);
